export function pairLessOrEqual(a, b) {
    if (a[0] !== b[0]) {
        return a[0] <= b[0];
    }
    else {
        return a[1] <= b[1];
    }
}
export function tripletLessOrEqual(a, b) {
    if (a[0] !== b[0]) {
        return a[0] < b[0];
    }
    else if (a[1] !== b[1]) {
        return a[1] < b[1];
    }
    else {
        return a[2] <= b[2];
    }
}
export function pairEqual(a, b) {
    return a[0] === b[0] && a[1] === b[1];
}
export function tripleEqual(a, b) {
    return a[0] === b[0] && a[1] === b[1] && a[2] === b[2];
}
